import { ORDER_PACKING_LIST_API } from "../../shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import { CreatedOrderPackingListModel } from "./order-packing-list.models";

export const createOrderPackingListApi = async (
  model: CreatedOrderPackingListModel
) => {
  return await apiClient.postHttp(`${ORDER_PACKING_LIST_API}`, model);
};

export const receivedPackingListApi = async (orderShippingId: string) => {
  return await apiClient.putHttp(
    `${ORDER_PACKING_LIST_API}/${orderShippingId}/received`
  );
};

export const returningPackingListApi = async (orderShippingId: string) => {
  return await apiClient.putHttp(
    `${ORDER_PACKING_LIST_API}/${orderShippingId}/returning`
  );
};

export const returnedPackingListApi = async (orderShippingId: string) => {
  return await apiClient.putHttp(
    `${ORDER_PACKING_LIST_API}/${orderShippingId}/returned`
  );
};
